import api from '@pray/shared/utils/api';

import type { RecurringAudience, RecurringAudiencePayload } from './types';

// POST …/campaigns/recurring/:id/audiences — allowed on draft + active + stopped.
// The controller re-reads the parent so the returned audience DTO carries the
// resolved name + lead_count, not just the bare row.
export async function addRecurringAudience({
  artistId,
  recurringCampaignId,
  audience,
}: {
  artistId: string;
  recurringCampaignId: string;
  audience: RecurringAudiencePayload;
}): Promise<{ object: RecurringAudience }> {
  if (!artistId) throw new Error('Artist ID is required');
  if (!recurringCampaignId) throw new Error('Recurring campaign ID is required');

  const url = `/web/studio/artists/${artistId}/campaigns/recurring/${recurringCampaignId}/audiences`;
  const response = await api.executePostRequest<{ data: { object: RecurringAudience } }>(url, audience);
  return response.data.data;
}
